import { createAnimation } from '@ionic/react'

export const enterAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot as ShadowRoot

  const backdropAnimation = createAnimation()
    .addElement(root.querySelector('ion-backdrop') as Element)
    .fromTo('opacity', '0.01', 'var(--backdrop-opacity)')
    .keyframes([{ opacity: '0' }, { opacity: '1' }])

  const wrapperAnimation = createAnimation()
    .addElement(root.querySelector('.modal-wrapper') as Element)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scale(0)' },
      { offset: 1, opacity: '1', transform: 'scale(1)' },
    ])

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(150)
    .addAnimation([backdropAnimation, wrapperAnimation])
}

export const leaveAnimation = (baseEl: HTMLElement) => {
  return enterAnimation(baseEl).direction('reverse')
}
